'use strict';

/*global services*/

function CatalogCalendar(containerID) {
    this.containerID = containerID;
    this.$container = null;

    this.saveTimeout = null;
    this.saveDelay = 500;
    this.saveNotificationTime = 2000;

    this.init();
}

CatalogCalendar.prototype = $.extend({}, {
    construtor: 'CatalogCalendar',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.off('click', '.catalog-calendar__copy');
        _this.$container.on('click', '.catalog-calendar__copy', function copySelectionsClb(e) {
            _this.copySelections($(this).closest('.catalog-calendar__header').next('.catalog-calendar__content'));

            return false;
        });

        _this.$container.off('change', '.catalog-calendar__setting--day');
        _this.$container.on('change', '.catalog-calendar__setting--day', function changeDaySettingClb(e) {
            _this.changeDaySetting($(this));

            return false;
        });

        _this.$container.off('change', '.catalog-calendar__setting--interval');
        _this.$container.on('change', '.catalog-calendar__setting--interval', function changeIntervalSettingClb(e) {
            _this.changeIntervalSetting($(this));

            return false;
        });

        _this.$container.off('change', '.catalog-calendar__option--interval');
        _this.$container.on('change', '.catalog-calendar__option--interval', function changeIntervalOptionClb(e) {
            _this.changeIntervalOption($(this));

            return false;
        });

        return _this;
    },

    //**************************************************************************

    copySelections: function copySelections($content) {
        var _this = this;

        var $intervals = $content.find('.catalog-calendar__setting--interval:checked');
        var $otherContents = $content.nextAll('.catalog-calendar__content');
        var $oldIntervals = $otherContents.find('.catalog-calendar__setting--interval:checked');

        $.each($intervals, function () {
           var $interval = $(this);
           var day = $interval.data('day');
           var interval = $interval.data('interval');
           var $otherIntervals = $otherContents.find('.catalog-calendar__setting--interval[data-day="' + day + '"][data-interval="' + interval + '"]');

           $otherIntervals.prop('checked', true);
           $otherIntervals.trigger('change');

           $oldIntervals = $oldIntervals.not($otherIntervals);
        });

        $oldIntervals.prop('checked', false).trigger('change');

        return _this;
    },

    changeDaySetting: function changeDaySetting($checkbox) {
        var _this = this;

        var $content = $checkbox.closest('.catalog-calendar__content');
        var day = $checkbox.data('day');
        var $intervals = $content.find('.catalog-calendar__setting--interval[data-day="' + day + '"]');

        $.each($intervals, function () {
            var $interval = $(this);

            if ($checkbox.is(':checked')) {
                $interval.prop('checked', true);
            } else {
                $interval.prop('checked', false);
            }

            $interval.trigger('change');
        });

        return _this;
    },

    changeIntervalSetting: function changeIntervalSetting($checkbox) {
        var _this = this;

        var $content = $checkbox.closest('.catalog-calendar__content');
        var day = $checkbox.data('day');
        var interval = $checkbox.data('interval');
        var $intervals = $content.find('.catalog-calendar__option--interval[data-day="' + day + '"][data-interval="' + interval + '"]');

        $.each($intervals, function () {
            var $interval = $(this);

            if (($checkbox.is(':checked') && !$interval.is(':checked')) || (!$checkbox.is(':checked') && $interval.is(':checked'))) {
                if ($checkbox.is(':checked')) {
                    $interval.prop('checked', true);
                } else {
                    $interval.prop('checked', false);
                }

                $interval.trigger('change');
            }
        });

        return _this;
    },

    changeIntervalOption: function changeIntervalOption($checkbox) {
        var _this = this;

        clearTimeout(_this.saveTimeout);

        $checkbox.attr('data-to_save', 1);

        _this.saveTimeout = setTimeout(function () {
            //provedeme ulozeni zmen
            var $checkboxes = _this.$container.find('input[data-to_save="1"]');
            $checkboxes.attr('data-to_save', 0);

            _this.saveIntervals($checkboxes);
        }, _this.saveDelay);

        return _this;
    },

    saveIntervals: function saveIntervals($intervals) {
        var _this = this;

        var $catalogCalendar = $intervals.closest('.catalog-calendar');

        var data = [];
        $intervals.each(function () {
            var $interval = $(this);

            //pouze ty, ktere jsou dostupne
            if ($interval.val() === '1') {
                data.push({
                    day: $interval.data('day'),
                    date: $interval.data('date'),
                    interval: $interval.data('interval'),
                    checked: $interval.is(':checked') ? 1 : 0,
                    value: $interval.val()
                });
            }
        });

        if (!data.length) {
            //pokud nemam zadne intervaly k ulozeni, tak koncim
            return;
        }

        var filterData = {};
        if (services.has('catalogFilter')) {
            filterData = services.get('catalogFilter').getFilterValues();
        }

        var postData = $.extend({}, filterData, {
            id: $catalogCalendar.data('item_id'),
            data: data
        });

        $.post(services.get('configurations').param('DomainURL') + '?action=' + services.get('configurations').param('Module') + '&method=js_change_reservations', postData, function (res) {
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.viewSaveNotification($intervals);
                } else if (res.msg === 'NOT_AVAILABLE') {
                    var modal = services.get('modal');
                    modal.open({
                        width: 'md',
                        height: 'auto',
                        title: services.get('translator').trans('CalendarReservation_ItemCapacityIsNotAvailable'),
                        content: services.get('translator').trans('CalendarReservation_ItemCapacityIsNotAvailableHelp')
                    });

                    if (services.has('catalogFilter')) {
                        services.get('catalogFilter').doItemsSearch();
                    }
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    viewSaveNotification: function viewSaveNotification($intervals) {
        var _this = this;

        var $header = $intervals.closest('.catalog-calendar__content').prev('.catalog-calendar__header');
        var $saveNotification = $header.find('.catalog-calendar__save-notification');

        $header.addClass('catalog-calendar__header--saved');
        $saveNotification.fadeIn('show');
        setTimeout(function () {
            $header.removeClass('catalog-calendar__header--saved');
            $saveNotification.fadeOut('slow');
        }, _this.saveNotificationTime);

        return _this;
    },

    //**************************************************************************

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerID);
        _this.registerCallbacks();

        return _this;
    }
});
